import React from "react";
import {
  FaHome,
  FaGift,
  FaCompass,
  FaPrayingHands,
  FaEnvelope,
  FaHeart,
  FaCommentDots,
} from "react-icons/fa";

const Sidebar = () => {
  return (
    <nav className="fixed top-0 right-0 h-full w-20 bg-transparent flex flex-col items-center justify-center space-y-6 z-50">
      {/* Navbar Items */}
      <ul className="space-y-6">
        {/* Home */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#home"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaHome size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            الرئيسية
          </span>
        </li>

        {/* Offers */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#offers"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaGift size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            العروض
          </span>
        </li>

        {/* Explore */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#explore"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaCompass size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            استكشاف
          </span>
        </li>
        {/* Prayers */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#prayers"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaPrayingHands size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            عبادات
          </span>
        </li>
        {/* Testimonials */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#testimonials"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaCommentDots size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            آراء العملاء
          </span>
        </li>

        {/* Why Choose Us */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#why-choose-us"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaHeart size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            لماذا تختارنا؟
          </span>
        </li>


        {/* Contact Us */}
        <li className="group relative flex flex-col items-center">
          <a
            href="#contact"
            className="flex flex-col items-center text-white hover:text-green-400 transition-all duration-300"
          >
            <FaEnvelope size={24} className="group-hover:scale-125 transition-transform duration-300" />
          </a>
          <span className="absolute right-8 px-6 py-4 text-nowrap text-sm text-white bg-black rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            اتصل بنا
          </span>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
